export default __webpack_public_path__ + "static/media/Menu_Casual_Socks.17548365.svg";